import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { Money } from "./Money";

export const PaymentList = ({ payments }) => {
  const { t } = useTranslation();
  return (
    <div className="grid gap-2" data-testid="payment-list">
      {payments.map((p) => (
        <NeuCard key={p.id} className="flex flex-wrap items-center gap-3 p-3" data-testid={`payment-row-${p.id}`}>
          <span className="font-mono text-xs" dir="ltr">{p.date}</span>
          <span className="min-w-0 flex-1 truncate text-xs font-semibold">
            {t(`acct.${p.kind === "supplier_payment" ? "supplierPayment" : "customerReceipt"}`)}
          </span>
          <Money value={p.amount} currency={p.currency} className="text-sm font-bold" />
          <span className="font-mono text-[11px] text-primary" dir="ltr">{p.entry_number}</span>
        </NeuCard>
      ))}
    </div>
  );
};
